// extracted by mini-css-extract-plugin
module.exports = {"inner-wrapper":"_16Rdr","flex-grid":"_1tCHQ","now-playing":"_1DIT9","iframeYT":"_1fzs8","video-list":"_1nExu","video-item":"nggGM","thumb":"_2tKyx","video-title":"_2Jh-c"};